import React, { useCallback, useState } from "react";
import { Table } from "../../../../component/table/Table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMastersVariantState,
  setVariantFilters,
} from "../../../../store/mastersVariantFilterSlice";
import { masterSpareColumnConfig } from "./masterSpareColumnConfig";

export const MasterSpareTablePage = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const masterVariantState = useSelector(selectMastersVariantState);
  const handleVariant = useCallback(
    (rowData) => {
      console.log(rowData);

      // dispatch(
      //   setVariantFilters({
      //     brand: rowData.brand,
      //     model: rowData.model,
      //   })
      // );
      const queryParams = new URLSearchParams({
        brand: rowData.brand,
        model: rowData.model,
      }).toString();
      navigate(`variants?${queryParams}`);
    },
    [dispatch, navigate]
  );

  const columnDefs = masterSpareColumnConfig(handleVariant);

  
  return <Table data={data} columns={columnDefs} />;
};
